<template>
  <div>
    <b-modal
      id="UpdateUserModal"
      size="lg"
      content-class="sub-menu-bg-blue-transparent uum-modal"
      title="Update User"
      hide-footer
     
      @shown="initModal()"
      @hidden="form.password = null"
    >
      <!-- Back Button -->
      <div v-if="user.role != 'USHR Acquisition Admin'" class="uum-back-row">
        <a href="#" class="uum-back-link" @click="back()">Back To User Accounts</a>
      </div>

      <div class="mm-form">

        <!-- Name -->
        <div class="mm-field">
          <label class="mm-label">Name *</label>
          <input v-model="form.name" class="mm-input" placeholder="Enter name" />
        </div>

        <!-- Email -->
        <div class="mm-field">
          <label class="mm-label">Email *</label>
          <input v-model="form.email" class="mm-input" placeholder="Enter email" />
        </div>

        <!-- Organization -->
        <div class="mm-field">
          <label class="mm-label">Organization *</label>
          <select v-model="form.org" class="mm-input mm-select">
            <option :value="null" disabled>Select organization...</option>
            <option v-for="org in organizations" :key="org.id" :value="org.id">
              {{ org.company_name }}
            </option>
          </select>
        </div>

        <!-- Authorization -->
        <div class="mm-field">
          <label class="mm-label">Authorization *</label>
          <select v-model="form.authorization" class="mm-input mm-select">
            <option :value="null" disabled>Select authorization...</option>
            <option v-for="obj in permissions" :key="obj.id" :value="obj">
              {{ obj.role_name }}
            </option>
          </select>
        </div>

        <!-- Group -->
        <div class="mm-field">
          <label class="mm-label">Group *</label>
          <select v-model="form.group" class="mm-input mm-select">
            <option :value="null" disabled>Select group...</option>
            <option v-for="obj in groups" :key="obj.id" :value="obj.group_name">
              {{ obj.group_name }}
            </option>
          </select>
        </div>

        <!-- Change Password Toggle -->
        <div class="mm-field">
          <label class="uum-checkbox-label">
            <input type="checkbox" v-model="changePassword" class="uum-checkbox" />
            <span class="uum-checkbox-custom"></span>
            <span class="uum-checkbox-text">Change Password</span>
          </label>
        </div>

        <!-- Password -->
        <div class="mm-field" v-if="changePassword">
          <label class="mm-label">Password *</label>
          <input
            type="text"
            name="password"
            placeholder="Password"
            autocomplete="off"
            v-model="form.password"
            class="mm-input"
          />
        </div>

        <!-- Password Note -->
        <div v-if="changePassword" class="uum-note">
          Note: You can edit or paste your own password.
        </div>

      </div>

      <!-- Errors -->
      <div v-if="formSubmitErrors.length" class="uum-errors">
        <div
          class="alert alert-danger"
          v-for="error in formSubmitErrors"
          :key="error"
        >{{ error }}</div>
      </div>

      <!-- Success -->
      <div v-if="submitSuccess" class="uum-success">
        <span class="alert alert-success">{{ submitSuccess }}</span>
      </div>

      <!-- Buttons -->
      <div class="mm-actions uum-actions">
        <b-button variant="secondary" size="sm" @click="back()">Cancel</b-button>
        <b-button variant="primary" size="sm" @click="checkForm()">Update</b-button>
      </div>

    </b-modal>
  </div>
</template>

<style>
/* ─── Back link ──────────────────────────────────────────────── */
.uum-back-row {
  display: flex;
  justify-content: flex-end;
  padding: 0 0 8px;
}
.uum-back-link {
  font-size: 12.5px;
  color: #063c6d;
  text-decoration: none;
  opacity: 0.7;
}
.uum-back-link:hover { text-decoration: underline; color: #063c6d; opacity: 1; }

/* ─── Checkbox ───────────────────────────────────────────────── */
.uum-checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  margin: 0;
}
.uum-checkbox { display: none; }
.uum-checkbox-custom {
  width: 14px; height: 14px;
  border-radius: 3px;
  border: 1px solid rgba(6, 60, 109, 0.35);
  background: rgba(6, 60, 109, 0.06);
  flex-shrink: 0;
  transition: background 0.15s, border-color 0.15s;
  position: relative;
}
.uum-checkbox:checked + .uum-checkbox-custom {
  background: #063c6d;
  border-color: #063c6d;
}
.uum-checkbox:checked + .uum-checkbox-custom::after {
  content: '';
  position: absolute;
  left: 3px; top: 1px;
  width: 5px; height: 8px;
  border: 1.5px solid #fff;
  border-top: none; border-left: none;
  transform: rotate(45deg);
}
.uum-checkbox-text {
  font-size: 12.5px;
  color: #063c6d;
}

/* ─── Note ───────────────────────────────────────────────────── */
.uum-note {
  font-size: 12px;
  color: rgba(6, 60, 109, 0.55);
  text-align: center;
}

/* ─── Errors / Success ───────────────────────────────────────── */
.uum-errors { margin-top: 8px; }
.uum-success {
  display: flex;
  justify-content: center;
  margin-top: 8px;
}

/* ─── Actions override (center for this modal) ───────────────── */
.uum-actions {
  justify-content: center;
  gap: 12px;
  padding-top: 16px;
}

/* ─── White-body modal overrides for shared mm-* classes ─────── */
.uum-modal .mm-label {
  color: rgba(6, 60, 109, 0.7);
}
.uum-modal .mm-input {
  background: #f3f5f8 !important;
  border: 1px solid rgba(6, 60, 109, 0.2) !important;
  color: #063c6d !important;
}
.uum-modal .mm-input::placeholder {
  color: rgba(6, 60, 109, 0.35);
}
.uum-modal .mm-input:focus {
  background: #fff !important;
  border-color: #063c6d !important;
  box-shadow: 0 0 0 2px rgba(6, 60, 109, 0.12) !important;
}
.uum-modal .mm-select option {
  background: #fff;
  color: #063c6d;
}
</style>

<script>
import axios from 'axios'
import { generateSecureString } from '../../../utils/utils'
import update_user from '!!raw-loader!../../../emails/update_user.html'

export default {
  props: ['user', 'userId'],

  data() {
    return {
      formSubmitErrors: [],
      changePassword: false,

      form: {
        name: null,
        email: null,
        password: null,
        org: null,
        authorization: null,
        group: null,
        testAccount: 'False'
      },

      groups: [],
      permissions: [],
      organizations: [],
      submitSuccess: '',
      randomPassword: null,
      updateEntryId: null
    }
  },

  watch: {
    changePassword(val) {
      if (val) {
        this.generatePassword()
      } else {
        this.form.password = null
      }
    }
  },

  methods: {
    initModal() {
      this.getRoles()
      this.getCompanies()
      this.getGroups()
      this.editEntry()
    },

    checkForm() {
      this.formSubmitErrors = []

      if (!this.form.name) this.formSubmitErrors.push('User Name required.')
      if (!this.form.email) this.formSubmitErrors.push('User Email required.')
      if (!this.form.org) this.formSubmitErrors.push('Organization required.')
      if (!this.form.authorization) this.formSubmitErrors.push('Authorization required.')

      if (this.changePassword) {
        if (!this.form.password) {
          this.formSubmitErrors.push('Password required.')
        }
        if (this.form.password && this.form.password.length < 6) {
          this.formSubmitErrors.push('Password must be 6+ characters.')
        }
      }

      if (!this.formSubmitErrors.length) {
        this.updateForm()
      }
    },

    async updateForm() {
      let params = {
        name: this.form.name,
        email: this.form.email.replace(/\s/g, ''),
        org: this.form.org,
        authorization: {
          permissions: this.form.authorization.role_name,
          testAccount: this.form.testAccount,
          group: this.form.group
        },
        user_roles_id: this.form.authorization.id
      }

      if (this.changePassword) {
        params.password = this.form.password.replace(/\s/g, '')
      }

      await axios.put(
        process.env.API_LOCATION + '/api/users/updateUser/' + this.updateEntryId, null,
        {
          headers: {
            'x-auth-token': sessionStorage.token
          },
          params
        }
      ).catch(function (error) {
        console.log(error)
        this.$bvToast.toast(`An error occured while updating user account for ${name}. Please try again later.`, {
          autoHideDelay: 10000,
          variant: 'danger',
          solid: true,
          title: 'User Updated Failed',
          toaster: 'b-toaster-top-right'
        })
      })
      this.sendConfirmationEmail()
      let name = JSON.stringify(this.form.name)
      this.$bvToast.toast(`User account for ${name} is updated.`, {
        autoHideDelay: 10000,
        variant: 'success',
        solid: true,
        title: 'User Updated Successfully',
        toaster: 'b-toaster-top-right'
      })
      this.back()
    },

    editEntry() {
      axios.get(process.env.API_LOCATION + '/api/users/user', {
        headers: { 'x-auth-token': sessionStorage.token },
        params: { id: this.userId }
      }).then(res => {
        const u = res.data.rows[0]
        this.form.name = u.name
        this.form.email = u.email
        this.form.org = u.org
        this.form.group = u.authorization.group
        this.form.authorization =
          this.permissions.find(p => p.id == u.user_roles_id)
        this.updateEntryId = u.id
      })
    },

    generatePassword() {
      this.form.password = generateSecureString(8)
    },

    back() {
      this.$bvModal.hide('UpdateUserModal')
    },

    getRoles() {
      axios.get(process.env.API_LOCATION + '/api/users/activeRoles', {
        headers: { 'x-auth-token': sessionStorage.token }
      }).then(res => (this.permissions = res.data.rows))
    },

    getCompanies() {
      axios.get(process.env.API_LOCATION + '/api/company/', {
        headers: { 'x-auth-token': sessionStorage.token }
      }).then(res => (this.organizations = res.data))
    },

    getGroups() {
      axios.get(process.env.API_LOCATION + '/api/users/groups', {
        headers: { 'x-auth-token': sessionStorage.token }
      }).then(res => (this.groups = res.data.rows))
    },

    sendConfirmationEmail() {      
      let name = this.form.name
      let email = this.form.email.replace(/\s/g, '')

      // Only include password if user chose to change it
      let password = this.changePassword
        ? this.form.password.replace(/\s/g, '')
        : null

      const fromEmail = 'mmp-info@dmp-maps.com'
      const toEmail = [email]
      const emailSubject = 'Your account has been updated on Map Management Platform'

      let year = new Date().getFullYear()

      let emailBody = update_user

      // Replace basic fields
      emailBody = emailBody
        .replace('{{ name }}', name)
        .replace('{{ email }}', email)
        .replace('{{ year }}', year)

      if (password) {
        emailBody = emailBody
          .replace('<!-- PASSWORD_BLOCK -->', '')
          .replace('<!-- END_PASSWORD_BLOCK -->', '')
          .replace('{{ password }}', password)
      } else {
        // Remove entire password section
        emailBody = emailBody.replace(
          /<!-- PASSWORD_BLOCK -->[\s\S]*<!-- END_PASSWORD_BLOCK -->/,
          ''
        )
      }

      if (sessionStorage.token) {
        axios.post(
          process.env.API_LOCATION + '/api/email/sendemail',
          {
            fromEmail,
            toEmail,
            emailSubject,
            emailBody
          },
          {
            headers: {
              'x-auth-token': sessionStorage.token
            }
          }
        )
        .then(response => {
          const content = response.data

          if (!content.errors) {
            this.$bvToast.toast('Account update email sent.', {
              autoHideDelay: 5000,
              variant: 'success',
              solid: true,
              title: 'Email Sent',
              toaster: 'b-toaster-top-right'
            })
          }
        })
        .catch(error => {
          console.log(error)
        })

      } else {
        console.log("No User Token")
        this.$router.push({ name: 'Login' })
      }
    }
  }
}
</script>